
interface WhyChooseSectionProps {
  language: 'es' | 'en';
}

export default function WhyChooseSection({ language }: WhyChooseSectionProps) {
  const content = {
    es: {
      title: '¿Por qué elegirnos?',
      subtitle: 'Más que una agencia, somos tu primer amigo en Japón.',
      reasons: [
        {
          icon: '🤝',
          title: 'Atención personalizada y humana',
          description: 'Cada cliente recibe un trato único y cercano, adaptado a sus necesidades específicas.'
        },
        {
          icon: '🎯',
          title: 'Asesoramiento real de alguien que ya vivió la experiencia',
          description: 'Juampi pasó por el mismo proceso y entiende perfectamente los desafíos que enfrentas.'
        },
        {
          icon: '🌍',
          title: 'Comunicación en español, inglés y japonés',
          description: 'Sin barreras de idioma. Nos comunicamos en tu lengua materna y traducimos todo lo necesario.'
        },
        {
          icon: '🛡️',
          title: 'Acompañamiento completo, no solo trámites',
          description: 'Te ayudamos desde el aeropuerto hasta que te sientas completamente integrado en Japón.'
        }
      ]
    },
    en: {
      title: 'Why Choose Us?',
      subtitle: 'More than an agency, we are your first friend in Japan.',
      reasons: [
        {
          icon: '🤝',
          title: 'Personalized and human attention',
          description: 'Each client receives unique and close treatment, adapted to their specific needs.'
        },
        {
          icon: '🎯',
          title: 'Real advice from someone who lived the experience',
          description: 'Juampi went through the same process and perfectly understands the challenges you face.'
        },
        {
          icon: '🌍',
          title: 'Communication in Spanish, English and Japanese',
          description: 'No language barriers. We communicate in your native language and translate everything necessary.'
        },
        {
          icon: '🛡️',
          title: 'Complete support, not just procedures',
          description: 'We help you from the airport until you feel completely integrated in Japan.'
        }
      ]
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-red-600 to-red-700">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {content[language].title} 💬
            </h2>
            <p className="text-xl text-red-100 max-w-3xl mx-auto font-medium">
              {content[language].subtitle}
            </p>
          </div>

          {/* Reasons Grid */}
          <div className="grid md:grid-cols-2 gap-8">
            {content[language].reasons.map((reason, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all transform hover:-translate-y-2"
              >
                <div className="flex items-start space-x-4">
                  <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center text-2xl flex-shrink-0">
                    {reason.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-3">
                      {reason.title}
                    </h3>
                    <p className="text-red-100 leading-relaxed">
                      {reason.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Community Section */}
          <div className="mt-16 text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8">
              <h3 className="text-2xl font-bold text-white mb-4">
                🌍 {language === 'es' ? 'Comunidad & Futuro' : 'Community & Future'}
              </h3>
              <p className="text-red-100 text-lg leading-relaxed max-w-4xl mx-auto">
                {language === 'es' 
                  ? 'First Step Japan está construyendo una comunidad de latinos que se apoyan mutuamente en Japón. Nuestros objetivos futuros incluyen meetups, colaboraciones con escuelas y negocios locales.'
                  : 'First Step Japan is building a community of Latinos supporting each other in Japan. Our future goals include meetups, collaborations with schools and local businesses.'
                }
              </p>
              <p className="text-yellow-300 text-xl font-semibold mt-4">
                {language === 'es' 
                  ? '"Construyendo puentes entre Japón y Latinoamérica."'
                  : '"Building bridges between Japan and Latin America."'
                }
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
